module.exports = __webpack_public_path__ + "img/Search.5964fec5.svg";